import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useSelectedServiceName from './use-selected-service-name';
import Global from '../../store/global-selectors';
import { ShippingStrategyDefaultTagWithName } from '../shipping-strategy-default-tag/shipping-strategy-default-tag-with-name';

/**
 * @param {object} props
 * @param {string} props.serviceId
 * @param {string} props.sellerLabelProviderId
 * @param {string} props.serviceCollectionGuid
 * @param {boolean} props.isTemplate
 * @returns {JSX.Element | string}
 */
export const ShippingServiceDropdownSelectedValue = memo(({ serviceId, sellerLabelProviderId, serviceCollectionGuid, isTemplate }) => {
  const sharedByPartnerServices = useSelector(Global.selectCarrierSharingserviceGroups);

  const selectedServiceItem = useMemo(
    () => ({
      serviceId: serviceCollectionGuid ? undefined : serviceId,
      sellerLabelProviderId: serviceCollectionGuid ? undefined : sellerLabelProviderId,
      serviceCollectionGuid,
    }),
    [serviceId, sellerLabelProviderId, serviceCollectionGuid],
  );

  const serviceName = useSelectedServiceName(selectedServiceItem, serviceId, sharedByPartnerServices);

  return serviceCollectionGuid && isTemplate ? <ShippingStrategyDefaultTagWithName name={serviceName} /> : serviceName;
});
